import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function SettingsList() {
    const [settings, setSettings] = useState([]);

    const fetchSettings = async () => {
        try {
            const res = await axios.get(process.env.REACT_APP_API_URL + 'settings');
            setSettings(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this setting?')) {
            try {
                await axios.delete(process.env.REACT_APP_API_URL + 'settings/' + id);
                fetchSettings();
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <div className='container mt-4'>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <h4>Settings</h4>
                <Link to='/createSetting' className='btn btn-primary'>Add Setting</Link>
            </div>
            <table className='table table-bordered table-striped'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Setting Key</th>
                        <th>Setting Value</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {settings.map((s, index) => (
                        <tr key={s.id}>
                            <td>{index + 1}</td>
                            <td>{s.setting_key}</td>
                            <td>{s.setting_value}</td>
                            <td>
                                <Link to={`/settingUpdate/${s.id}`} className='btn btn-sm btn-warning me-2'>Edit</Link>
                                <button onClick={() => handleDelete(s.id)} className='btn btn-sm btn-danger'>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default SettingsList;